import React from "react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

const About = () => {
  const [ref, inView] = useInView({
    threshold: 0.1,
    triggerOnce: true,
  });

  return (
    <section id="about" className="about" ref={ref}>
      <div className="container">
        <div className="about-content">
          <motion.div
            className="about-text"
            initial={{ opacity: 0, x: -50 }}
            animate={inView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.8 }}
          >
            <h2 className="section-title">About Digify.world</h2>
            <p>
              Founded in February 2023, Digify is a passionate digital marketing
              agency built to help brands grow and stand out in the digital
              world. From day one, our focus has been on delivering impactful
              and creative solutions that drive real results.
            </p>
            <p>
              What sets us apart is our dedication to innovation, transparency,
              and building long-term relationships. We’ve earned the trust of
              our clients through consistent performance and a deep
              understanding of their goals.
            </p>
            <p>
              Today, Digify proudly serves a growing list of happy clients, and
              we’re just getting started. Join us as we continue to shape
              digital success stories with purpose and passion.
            </p>
            <a href="#contact" className="btn">
              Learn More
            </a>
          </motion.div>

          <motion.div
            className="about-image"
            initial={{ opacity: 0, x: 50 }}
            animate={inView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.8 }}
          >
            <img
              src="https://images.unsplash.com/photo-1551434678-e076c223a692?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80"
              alt="Our professional team working together"
              className="about-img"
            />
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;
